import * as React from 'react';
export var UiKitToastsContext = /*#__PURE__*/React.createContext({
  containersPlacements: ['bottom-center', 'bottom-right', 'top-right', 'top-center'],
  toastsStacksApi: {
    'bottom-center': [[], function () {}],
    'bottom-right': [[], function () {}],
    'top-right': [[], function () {}],
    'top-center': [[], function () {}]
  }
});
export function useUiKitToastsContext() {
  return React.useContext(UiKitToastsContext);
}
export var UiKitToastApiContext = /*#__PURE__*/React.createContext({
  apiByPlacement: {
    'bottom-center': null,
    'bottom-right': null,
    'top-right': null,
    'top-center': null
  },
  setToastApiByPlacement: function setToastApiByPlacement() {},
  setIndentByPlacement: function setIndentByPlacement() {},
  indentByPlacement: {
    'bottom-center': '',
    'bottom-right': '',
    'top-right': '',
    'top-center': ''
  }
});
export function useUiKitToastApiContext() {
  return React.useContext(UiKitToastApiContext);
}